var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "31px",
    viewBox: "0 0 24 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "85106F46-3048-470F-AD9D-5549B785D10C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3193218,0.298293391 C13.83617,0.298293391 14.329501,0.515744971 14.6800689,0.898086637 L23.3607471,10.36554 C23.6765117,10.7099239 23.8518519,11.1614056 23.8518519,11.6300804 L23.8518519,27.1446986 C23.8518519,28.7921275 22.5252881,30.1276325 20.8888889,30.1276325 L3.11111111,30.1276325 C1.47471185,30.1276325 0.148148148,28.7921275 0.148148148,27.1446986 L0.148148148,3.28122731 C0.148148148,1.6337984 1.47471185,0.298293391 3.11111111,0.298293391 L13.3193218,0.298293391 Z M12.8328426,3.28122731 L3.48148148,3.28122731 C3.27693157,3.28122731 3.11111111,3.44816543 3.11111111,3.65409405 L3.11111111,26.7718319 C3.11111111,26.9777605 3.27693157,27.1446986 3.48148148,27.1446986 L20.5185185,27.1446986 C20.7230684,27.1446986 20.8888889,26.9777605 20.8888889,26.7718319 L20.8888889,12.067435 L12.8328426,3.28122731 Z M16.8148148,20.4330973 C17.6296296,20.4330973 18.2962963,21.1042574 18.2962963,21.9245643 C18.2962963,22.7448711 17.6296296,23.4160312 16.8148148,23.4160312 L7.18518519,23.4160312 C6.37037037,23.4160312 5.7037037,22.7448711 5.7037037,21.9245643 C5.7037037,21.1042574 6.37037037,20.4330973 7.18518519,20.4330973 L16.8148148,20.4330973 Z M13.8518519,14.4672295 C14.6666667,14.4672295 15.3333333,15.1383896 15.3333333,15.9586964 C15.3333333,16.7790033 14.6666667,17.4501634 13.8518519,17.4501634 L7.18518519,17.4501634 C6.37037037,17.4501634 5.7037037,16.7790033 5.7037037,15.9586964 C5.7037037,15.1383896 6.37037037,14.4672295 7.18518519,14.4672295 L13.8518519,14.4672295 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Campaign_06.3.1",
    transform: "translate(-673.000000, -851.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(328.000000, 736.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(329.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "color",
    fill: "currentColor",
    mask: "url(#mask-2)",
    x: -6.5,
    y: -3,
    width: 37,
    height: 36.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperIcon);
export default __webpack_public_path__ + "static/media/PaperIcon.ee4d99bf466b428faea198309f97a7cb.svg";
export { ForwardRef as ReactComponent };